import { MART_CATEGORY_ACTION_TYPE, MartCategoryActions } from './martCategory-type';
import { RootState } from '../../../../redux/root-reducer';
import { Tags } from '@ppvrbh/merchant-frontend-core';

export enum MART_CATEGORY_STATE_KEY {
  TAG_LIST = 'tag_list',
  CATEGORY_LIST = 'category_list',
  IS_ALERT_SUCCESS = 'is_alert_success',
  IS_ALERT_FAILURE = 'is_alert_failure',
  MASTER_DATA = 'master_data'
}

export type MartCategoryState = {
  [MART_CATEGORY_STATE_KEY.TAG_LIST]: Tags[],
  [MART_CATEGORY_STATE_KEY.CATEGORY_LIST]?: object,
  [MART_CATEGORY_STATE_KEY.IS_ALERT_SUCCESS]?: boolean,
  [MART_CATEGORY_STATE_KEY.IS_ALERT_FAILURE]?: boolean,
  [MART_CATEGORY_STATE_KEY.MASTER_DATA]?: []
};

const initialState: MartCategoryState = {
  [MART_CATEGORY_STATE_KEY.TAG_LIST]: [],
  [MART_CATEGORY_STATE_KEY.CATEGORY_LIST]: [],
  [MART_CATEGORY_STATE_KEY.IS_ALERT_SUCCESS]: false,
  [MART_CATEGORY_STATE_KEY.IS_ALERT_FAILURE]: false,
  [MART_CATEGORY_STATE_KEY.MASTER_DATA]: []
};

export const martCategoryReducers = (state = initialState, action: MartCategoryActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case MART_CATEGORY_ACTION_TYPE.SET_MART_CATEGORY_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const martCategoryStateSelector = (key: MART_CATEGORY_STATE_KEY) => (state: RootState) => state.martCategory[key];
